import {
  Box,
  Card,
  CardContent,
  CardMedia,
  Container,
  Typography,
} from "@material-ui/core";
import useStyles from "./style";

const Approval = () => {
  const classes = useStyles();
  return (
    <CardMedia
      image="/assets/images/doctorBg.jpg"
      className={classes.containerImage}
    >
      <Container component="main" maxWidth="xs">
        <Box className={classes.boxContainer}>
          <Card className={classes.formBox}>
            <CardContent>
              <Typography
                gutterBottom
                variant="h5"
                component="h2"
                color="primary"
              >
                Activation Message
              </Typography>
              <Typography variant="body2" color="secondary" component="p">
                Your account is not activated yet. Please contact +8801629299242
                (call/sms/whatsapp) for activation of prescription software.
                Thanks.
              </Typography>
            </CardContent>
          </Card>
        </Box>
      </Container>
    </CardMedia>
  );
};

export default Approval;
